/**
 * Truncates text at the last space before the specified character limit
 * and appends ellipsis if needed
 * 
 * @param {string} text - The text to truncate
 * @param {number} limit - Maximum character limit
 * @returns {string} - Truncated text
 */
export const truncateAtLastSpace = (text, limit) => {
  if (!text || text.length <= limit) return text;
  
  const truncated = text.substring(0, limit);
  const lastSpaceIndex = truncated.lastIndexOf(' ');
  
  if (lastSpaceIndex === -1) return truncated + '...';
  return truncated.substring(0, lastSpaceIndex) + '...';
};
